if(typeof BSS_B2B) {
  window.bssB2BHooks = window.bssB2BHooks || {
      actions: {},
      filters: {},
  };
  
  window.BSS_B2B = window.BSS_B2B || {};
  
  window.BSS_B2B.addAction = (tag, callback) => {
      window.bssB2BHooks.actions[tag] = callback;
  }
  window.BSS_B2B.addFilter = (tag,  value) => {
      window.bssB2BHooks.filters[tag] = value;
  }
  function shippingRateCustomPrice({ shippingRatePriceOld, shippingRatePrice }) {
    if (shippingRatePriceOld > shippingRatePrice) {
        return shippingRatePriceOld;
    }
    return shippingRatePrice
  }
  function shippingRateCustomTitle({ shippingRatePriceOld, shippingRatePrice, shippingRateTitleOld, shippingRateTitle }) {
    if (shippingRatePriceOld > shippingRatePrice) {
        return shippingRateTitleOld;
    }
     return shippingRateTitle
  }
  window.BSS_B2B.addFilter('shipping_rate_custom_price', shippingRateCustomPrice);
  window.BSS_B2B.addFilter('shipping_rate_custom_title', shippingRateCustomTitle);
 if(window.location.pathname.includes("/pages/")) {
        const loop = setInterval(() =>{
            const submitBtn = $(".bss-b2b-rf-submit-button input[type='submit']");
            if(submitBtn.length) {
                clearInterval(loop);
                submitBtn.val("Absenden");
            }
        }, 500)
        setTimeout(() =>{
            clearInterval(loop);
        }, 7000)
    }

  window.addEventListener("cart_changed", () => {
    setTimeout(() => {
      let storeData = JSON.parse($("#bss-b2b-store-data").html());
      BSS_B2B.makeChangesAfterClickAjaxCart(500)
      BSS_B2B.cart.fixer(storeData, null, false);
      BSS_B2B.handleCartCheckoutBtn(storeData);
    }, 500);
  });

  //fix spam checkout 
  setTimeout(() =>{
    function handleButtonClick(e) {
      e.preventDefault();
      const $button = $(this);
      let oldText = $(this).text();
      $button.css({'pointer-events': 'none', 'opacity': '0.6'});
      $button.text("Loading ...");
      setTimeout(() =>{
        $button.css({'pointer-events': 'unset', 'opacity': '1'})
          $button.text(oldText);
      }, 2000);
    }
   
   $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
  }, 500)

BSS_B2B.customTriggerCheckoutBtn = function(checkoutBtn){
    window.location.href = "/checkout";
  }
  

  
}